import messaging from '@react-native-firebase/messaging';
import { UserServiceClient } from 'fitbeat.api-clients';
import { Platform } from 'react-native';
import { getApiConfig } from '../config';
import { AuthTokenBuilder } from './authTokenBuilder';
import { Logger } from './Logger';
import { Permissions } from './Permissions';

export const managePushNotificationPermissions = async () => {
  if (Platform.OS === 'web') {
    return;
  }

  if (Platform.OS === 'ios') {
    // On android 12 and under, permissions are granted by default
    const authStatus = await messaging().hasPermission();
    const hasPermission = authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
                          authStatus === messaging.AuthorizationStatus.PROVISIONAL;
    if (hasPermission) {
      return;
    }
  }

  await Permissions.requestNotificationPermission();

  try {
    await messaging().requestPermission();
    const fbToken = await messaging().getToken();
    const userServiceClient = new UserServiceClient(getApiConfig(), fetch, null, new AuthTokenBuilder());
    await userServiceClient.addDeviceToken(fbToken, Platform.OS);
  } catch (e) {
    if (!e.message.includes('Failed to grant permission')) {
      Logger.notify(e, (report) => {
        report.errorClass = 'managePushNotificationPermissions';
      });
    }
  }
};
